var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerkehrsrechtSonstiges(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 830.5 637.7",
    style: {
      enableBackground: "new 0 0 830.5 637.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3F3D56;}\n\t.st1{fill:#137F7B;}\n\t.st2{fill:#CCCCCC;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#F2F2F2;}\n\t.st5{fill:#E5E5E5;}\n\t.st6{fill:#FFB8B8;}\n\t.st7{fill:#2F2E41;}\n\t.st8{fill:#FFB7B7;}\n\t.st9{opacity:0.2;enable-background:new    ;}\n\t.st10{fill:#CBCBCB;}\n\t.st11{font-family:'Roboto-Regular';}\n\t.st12{font-size:56px;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 230.4,
    y: 565.1,
    className: "st0",
    width: 69.7,
    height: 11.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M803.8,567.6l-14.4,3.3l-546.3,0.3l-4.9-11.4c-8.6-19.6-11.5-41.3-8.5-62.5c2.4-15.8,8.2-31.5,21.6-38.3 l24.2-161.5l302.2-0.5l116.9,94.3c0,0,55.2-1,85.1,36.3c9.5,11.8,16.4,27.5,18.3,48.2l1.2,19.4L803.8,567.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 683.8,
    cy: 564.9,
    r: 67.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 683.8,
    cy: 564.9,
    r: 35.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 351,
    cy: 565,
    r: 67.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 351,
    cy: 565,
    r: 35.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "648.3,380.2 485.2,380.3 465.2,380.3 431.6,380.3 431.6,377.8 431.6,348.3 431.6,315.1 453.9,315.1  473.8,315 509.1,315 529.1,315 569.8,315  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "405.1,380.3 318.8,380.4 318.8,363.4 318.8,333.9 318.8,315.1 331.4,315.1 351.3,315.1 405,315.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.6,
    y: 429,
    className: "st0",
    width: 11.1,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 604.1,
    y: 399,
    className: "st0",
    width: 21,
    height: 11.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M611.8,357.6h1.2c12.8,0,23.1,10.3,23.1,23.1l0,0c0,12.8-10.3,23.1-23.1,23.1h-1.2l0,0V357.6L611.8,357.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M799.4,495.2c-19.6,2.1-37.2-12-39.4-31.7c-1.6-15,6.3-29.4,19.9-36c9.5,11.8,16.4,27.5,18.3,48.2 L799.4,495.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "473.8,315 431.6,377.8 431.6,348.3 453.9,315.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "351.3,315.1 318.8,363.4 318.8,333.9 331.4,315.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "529.1,315 485.2,380.3 465.2,380.3 509.1,315  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 757.2,
    cy: 550.3,
    r: 6.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.2,
    y: 592.7,
    className: "st5",
    width: 2,
    height: 44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 774.2,
    cy: 576.4,
    r: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M774.2,626.3c0,0-1.5-32.3-32.3-28.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M614.9,385.5c-4.9-2.9-6.4-9.2-3.5-14.1c0.3-0.5,0.7-1,1.1-1.5l-13.4-134.2l22.3,1.5l6.2,132.1 c4,4,4.1,10.6,0,14.6C624.2,387.3,619,387.9,614.9,385.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M630.5,230.7l-5.9,44.5l0.8,27.3l-24.6,2.2l-4.9-22.7l-2.7-60c-0.4-9.4,6.5-17.5,15.8-18.6l0,0 c9.7-1.1,18.5,5.7,19.8,15.4L630.5,230.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M239.4,69.8H148c-1.7,0-3.2-1.4-3.2-3.2c0-1.7,1.4-3.2,3.2-3.2h91.4c1.7,0,3.2,1.4,3.2,3.2 C242.6,68.4,241.1,69.8,239.4,69.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M216.6,91.6H148c-1.7,0-3.2-1.4-3.2-3.2c0-1.7,1.4-3.2,3.2-3.2h68.6c1.7,0,3.2,1.4,3.2,3.2 C219.7,90.2,218.3,91.6,216.6,91.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M377,361.2H110.5c-1.9,0-3.5-1.6-3.5-3.5V64.5c0-1.9,1.6-3.5,3.5-3.5H377c1.9,0,3.5,1.6,3.5,3.5v293.2 C380.5,359.6,378.9,361.2,377,361.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M377,361.2H110.5c-1.9,0-3.5-1.6-3.5-3.5V64.5c0-1.9,1.6-3.5,3.5-3.5H377c1.9,0,3.5,1.6,3.5,3.5v293.2 C380.5,359.6,378.9,361.2,377,361.2z M110.5,62.4c-1.2,0-2.1,0.9-2.1,2.1v293.2c0,1.2,0.9,2.1,2.1,2.1H377c1.2,0,2.1-0.9,2.1-2.1 V64.5c0-1.2-0.9-2.1-2.1-2.1H110.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.5,177h-96.1c-1.7,0-3.2-1.4-3.2-3.2v-66.1c0-1.7,1.4-3.2,3.2-3.2h96.1c1.7,0,3.2,1.4,3.2,3.2v66.1 C239.6,175.6,238.2,177,236.5,177z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M347.1,213.2H140.4c-1.7,0-3.2-1.4-3.2-3.2c0-1.7,1.4-3.2,3.2-3.2h206.7c1.7,0,3.2,1.4,3.2,3.2 C350.3,211.8,348.8,213.2,347.1,213.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M297.2,235H140.4c-1.7,0-3.2-1.4-3.2-3.2c0-1.7,1.4-3.2,3.2-3.2h156.8c1.7,0,3.2,1.4,3.2,3.2 C300.3,233.6,298.9,235,297.2,235C297.2,235,297.2,235,297.2,235z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.4,133.1H255c-1.7,0-3.2-1.4-3.2-3.2c0-1.7,1.4-3.2,3.2-3.2c0,0,0,0,0,0h91.4c1.7,0,3.2,1.4,3.2,3.2 C349.6,131.6,348.1,133.1,346.4,133.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M323.6,154.9H255c-1.7,0-3.2-1.4-3.2-3.2c0-1.7,1.4-3.2,3.2-3.2h68.6c1.7,0,3.2,1.4,3.2,3.2 C326.7,153.4,325.3,154.9,323.6,154.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M347.1,256.8H140.4c-1.7,0-3.2-1.4-3.2-3.2c0-1.7,1.4-3.2,3.2-3.2c0,0,0,0,0,0h206.7c1.7,0,3.2,1.4,3.2,3.2 C350.3,255.4,348.8,256.8,347.1,256.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M297.2,278.6H140.4c-1.7,0-3.2-1.4-3.2-3.2c0-1.7,1.4-3.2,3.2-3.2h156.8c1.7,0,3.2,1.4,3.2,3.2 C300.3,277.2,298.9,278.6,297.2,278.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M347.1,300.4H140.4c-1.7,0-3.2-1.4-3.2-3.2c0-1.7,1.4-3.2,3.2-3.2h206.7c1.7,0,3.2,1.4,3.2,3.2 C350.3,299,348.8,300.4,347.1,300.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M347.1,322.2H140.4c-1.7,0-3.2-1.4-3.2-3.2c0-1.7,1.4-3.2,3.2-3.2h206.7c1.7,0,3.2,1.4,3.2,3.2 C350.3,320.8,348.8,322.2,347.1,322.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "536.4,622.2 521.5,622.2 514.4,564.7 536.4,564.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M540.2,636.6l-48,0V636c0-10.3,8.4-18.7,18.7-18.7h0l29.3,0L540.2,636.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "659.4,622.2 644.5,622.2 637.4,564.7 659.4,564.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M663.2,636.6l-48,0V636c0-10.3,8.4-18.7,18.7-18.7h0l29.3,0L663.2,636.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 601.5,
    cy: 150,
    r: 32.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M597.3,195.4l22.4,2.6l0,0c11.1,15.7,13.9,35.7,7.6,53.9l-16.9,48.9c0,0,23.5,47.1,23.5,90.8 s44.7,199.7,44.7,199.7l-62.9,6.6l-27.5-166.2L550.4,597l-43.2-7L531,373l15.7-71.4l0.7-34.8c0,0-6.7-26.1,10-42.9l20.4-28.5 L597.3,195.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M577.8,390.9c-5.2-3.5-6.5-10.5-3-15.7c0.4-0.5,0.8-1.1,1.3-1.5l-6.7-147.6l24.3,2.9L592.6,374 c4.2,4.7,3.8,11.8-0.8,16C587.9,393.5,582.1,393.8,577.8,390.9L577.8,390.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M604,222.5l-9,48.3l-0.7,29.9l-27,1l-4-25.1l0.6-65.8c0.1-10.3,8.1-18.8,18.4-19.4l0,0 c10.7-0.7,20,7.4,20.8,18.1L604,222.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M563.8,138.4h47.5v-20.7c-10.4-4.1-20.6-7.7-26.8,0C573.1,117.7,563.8,127,563.8,138.4L563.8,138.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M613.9,114.1c28.4,0,36.3,35.6,36.3,55.6c0,11.2-5.1,15.2-13,16.5l-2.8-15l-6.6,15.6c-2.2,0-4.6,0-7-0.1 l-2.2-4.6l-5,4.5c-19.9,0-36,2.9-36-17C577.6,149.6,584.6,114.1,613.9,114.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "572,310.5 570.8,258.4 567.6,235.3 559.7,258.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M829.5,637.7h-381c-0.6,0-1-0.4-1-1s0.4-1,1-1h381c0.6,0,1,0.4,1,1S830.1,637.7,829.5,637.7z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 173.4652 161.3659)",
    className: "st3 st11 st12"
  }, "\u20AC"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerkehrsrechtSonstiges);
export default __webpack_public_path__ + "static/media/Verkehrsrecht_Sonstiges.2c3cc7728f53c8c8b0be6543eecc500b.svg";
export { ForwardRef as ReactComponent };